import Component from "./videoPlayer.component";
import { Config } from "./videoPlayer.config";
import { watchVideoPlayer as saga } from "./redux/videoPlayer.sagas";
import { reducer } from "./redux/videoPlayer.reducer";

export default { Component, saga, reducer, config: Config };
